import React, { useState, useEffect, useCallback } from "react";
import { useContext } from "react";
import { AuthContext } from "../AuthContext";
import axiosInstance from "../axiosConfig";
import "../assets/CSS/Dashboard.css";
import logo from "../assets/Img/Logo-1.png";
import User from "../assets/Img/User.gif";
import Bell from "../assets/Img/BellIcon.png";
import moment from "moment-timezone";
import Dispatch from "../assets/Img/Dispatch.png";
import { NavLink } from "react-router-dom";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import { CSVLink } from "react-csv"; 
import Select from "react-select"; 
import Swal from "sweetalert2"; // SweetAlert2 for validations

function Dashboard() {
  const [isSidebarVisible, setIsSidebarVisible] = useState(window.innerWidth > 991);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [workerRequirements, setWorkerRequirements] = useState([]); 
  const [searchQuery, setSearchQuery] = useState("");
  const [modalData, setModalData] = useState(null); 
  const [isModalOpen, setIsModalOpen] = useState(false); 
  const [presentEmployees, setPresentEmployees] = useState([]); 
  const [filteredPresentEmployees, setFilteredPresentEmployees] = useState([]);
  const [matchedData, setMatchedData] = useState([]); 
  const [filteredRequiredResources, setFilteredRequiredResources] = useState(0);
  const [workerAllocations, setWorkerAllocations] = useState([]); 
  const [departments, setDepartments] = useState([]);

  const [isAllocationModalOpen, setIsAllocationModalOpen] = useState(false); 
  const [filteredPresentWorkers, setFilteredPresentWorkers] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [users, setUsers] = useState([]);

  const [formData, setFormData] = useState({
    From_Dep: "",
    Worker_Name: "",
    To_Department: "",
  });

  // 💬 NEW STATES FOR DIRECT WHATSAPP FLOW
  const [isWhatsAppModalOpen, setIsWhatsAppModalOpen] = useState(false);
  const [whatsAppPayload, setWhatsAppPayload] = useState({
    phone: "",
    workerName: "",
    messageText: ""
  });

  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };

  const [limits, setLimits] = useState({});

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const { data } = await axiosInstance.get("/api/AllUsers"); 
        setUsers(data);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    fetchUsers();

    fetch('/config.json')
    .then(res => res.json())
    .then(data => setLimits(data));
  }, []);

  const fetchWorkerRequirements = useCallback(async () => {
    try {
      const response = await axiosInstance.get(
        "/api/departments/worker-requirements"
      );
      const fetchedRequirements = response.data;
      setWorkerRequirements(fetchedRequirements);

      const totalResources = fetchedRequirements.reduce(
        (sum, item) => sum + (item.RequiredResource || 0),
        0
      );
      setFilteredRequiredResources(totalResources);
    } catch (error) {
      console.error("Error fetching worker requirements:", error);
    }
  }, []);

  const fetchData = useCallback(async () => {
    try {
      const dataResponse = await axiosInstance.get("/api/data");
      const fetchedData = dataResponse.data;
      setData(fetchedData);

      const filterContainer = document.getElementById("filter-container");
      if (filterContainer) {
        filterContainer.innerHTML = ""; 

        const departmentGroups = fetchedData.reduce((acc, row) => {
          const dept = row["DEPARTMENT"] || "Department Not Available";
          acc[dept] = acc[dept] || [];
          acc[dept].push(row);
          return acc;
        }, {});

        Object.keys(departmentGroups).forEach((department) => {
          const rows = departmentGroups[department];
          const isRM = rows.some((row) => row.RawMaterial === "RmRequired"); 
          const hasPendingProcess = rows.some(
            (row) => row["PendingProcess"] === "Yes"
          );

          const resultColor = rows[0]["Result"]; 
          const workerStatus = rows[0]["WorkerStatus"]; 
          const wipQuantity = rows[0]["Wip_quantity"] || "0"; 
          
          const button = document.createElement("div");
          button.className = "filter-btn btn btn-outline-secondary";
          button.innerHTML = `
            <div class="button-content">
                <span class="button-text" style="${
                  hasPendingProcess ? "color: #0033cc;" : ""
                }">${department} 
                ${
                  isRM
                    ? '<sup style="font-size: 9px; color: rgb(10 183 0); font-weight: bold;">RM</sup>'
                    : ""
                }
                </span>
              <span class="button-lights">
                <label class="radio-wrapper">
                  <input type="radio" name="${department}-light" disabled ${
            resultColor === "Orange" ? "checked" : ""
          } />
                  <span class="radio orange-light ${
                    resultColor === "Orange" ? "active" : ""
                  }"></span>
                </label>
                <label class="radio-wrapper">
                  <input type="radio" name="${department}-light" disabled ${
            resultColor === "Green" ? "checked" : ""
          } />
                  <span class="radio green-light ${
                    resultColor === "Green" ? "active" : ""
                  }"></span>
                </label>
                <label class="radio-wrapper">
                  <input type="radio" name="${department}-light" disabled ${
            resultColor === "Red" ? "checked" : ""
          } />
                  <span class="radio red-light ${
                    resultColor === "Red" ? "active" : ""
                  }"></span>
                </label>
                <label class="radio-wrapper">
                  <input type="radio" name="${department}-light" disabled ${
            workerStatus === "Yes" ? "checked" : ""
          } />
                  <span class="radio blue-light ${
                    workerStatus === "Yes" ? "active" : ""
                  }"></span>
                </label>
                
              </span>
            </div>
          `;
          if (workerStatus === "Yes") {
            const blueLight = button.querySelector(".blue-light");
            if (blueLight) {
              blueLight.style.backgroundColor = "#cc66ff"; 
            }
          }

          button.setAttribute("data-bs-toggle", "tooltip");
          button.setAttribute("data-bs-placement", "top");
          button.setAttribute(
            "title",
            `Department: ${department}\nWIP Quantity: ${wipQuantity}`
          );

          button.onclick = () => {
            const filtered = fetchedData.filter(
              (row) => row["DEPARTMENT"] === department
            );
            setFilteredData(filtered);

            const departmentRequirement = workerRequirements.find(
              (req) => req.DEPARTMENT === department
            );
            setFilteredRequiredResources(
              departmentRequirement?.RequiredResource || 0
            );

            const filteredEmployees = presentEmployees.filter(
              (emp) => emp.Department === department
            );
            setFilteredPresentEmployees(filteredEmployees);
          };

          filterContainer.appendChild(button);
        });
      }
    } catch (error) {
      showAlert("Database Connection Lost", "danger");
    }
  }, [workerRequirements, presentEmployees]);

  const handleSearch = useCallback(() => {
    if (searchQuery.trim() === "") {
      setFilteredData(data);
    } else {
      const filtered = data.filter((row) => {
        const itemName = row["ITEM NAME"] ? row["ITEM NAME"].toLowerCase() : "";
        const jobOrderNo = row["JOB ORDER NO"]
          ? row["JOB ORDER NO"].toLowerCase()
          : "";

        return (
          itemName.includes(searchQuery.toLowerCase()) ||
          jobOrderNo.includes(searchQuery.toLowerCase())
        );
      });
      setFilteredData(filtered);
    }
  }, [data, searchQuery]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    handleSearch();
  }, [searchQuery, handleSearch]);

  const checkServerHealth = useCallback(async () => {
    try {
      const response = await axiosInstance.get("/api/health");
      if (response.data.status !== "connected") {
        showAlert("Database Connection Lost", "danger");
      }
    } catch (error) {
      showAlert("Database Connection Lost", "danger");
    }
  }, []);

  const fetchLastUpdatedDate = useCallback(async () => {
    try {
      const response = await axiosInstance.get("/api/data");

      if (response.data && response.data.length > 0) {
        const validRows = response.data.filter(
          (row) =>
            row["Updated_Time"] !== null && row["Updated_Time"] !== undefined
        );

        if (validRows.length > 0) {
          const lastUpdated = validRows.reduce((latest, current) => {
            return new Date(`1970-01-01T${current["Updated_Time"]}`) >
              new Date(`1970-01-01T${latest["Updated_Time"]}`)
              ? current
              : latest;
          });

          const formattedTime = lastUpdated["Updated_Time"]; 
          const updatedDateInput = document.getElementById("updatedDate");
          if (updatedDateInput) {
            updatedDateInput.value = formattedTime;
          }
        }
      }
    } catch (error) {
      console.error("Error fetching last updated time:", error);
    }
  }, []);

  useEffect(() => {
    const interval = setInterval(checkServerHealth, 5050);
    return () => clearInterval(interval);
  }, [checkServerHealth]);

  const handleViewAll = async () => {
    await fetchData(); 
  };

  useEffect(() => {
    fetchLastUpdatedDate();
    fetchPresentEmployees();
  }, [fetchLastUpdatedDate]);

  const fetchPresentEmployees = async () => {
    try {
      const response = await axiosInstance.get("/api/presentEmployees");
      setPresentEmployees(response.data);
      setFilteredPresentEmployees(response.data); 
    } catch (error) {
      console.error("Error fetching present employees:", error);
    }
  };

  useEffect(() => {
    fetchPresentEmployees();
    fetchWorkerRequirements();
  }, [fetchWorkerRequirements]);

  const fetchMatchedData = useCallback(async () => {
    if (!modalData) return;

    try {
      const response = await axiosInstance.get("/api/matched-data");
      const fetchedData = response.data;
      const filteredData = fetchedData.filter(
        (row) => row["JOB ORDER NO"] === modalData["JOB ORDER NO"]
      );

      setMatchedData(filteredData);
    } catch (error) {
      console.error("Error fetching matched data:", error);
    }
  }, [modalData]);

  useEffect(() => {
    if (isModalOpen && modalData) {
      fetchMatchedData();
    }
  }, [isModalOpen, modalData, fetchMatchedData]);

  const fetchWorkerAllocations = useCallback(async () => {
    try {
      const response = await axiosInstance.get("/api/worker-allocation");
      setWorkerAllocations(response.data);
    } catch (error) {
      console.error("Error fetching worker allocations:", error);
    }
  }, []);

  useEffect(() => {
    fetchWorkerAllocations();
  }, [fetchWorkerAllocations]);

  const csvHeaders = [
    { label: "From Department", key: "From_Dep" },
    { label: "Worker Name", key: "Worker_Name" },
    { label: "To Department", key: "To_Department" },
  ];

  const handleReactSelectChange = async (selectedOption, meta) => {
    const { name } = meta;
    const value = selectedOption ? selectedOption.value : "";

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));

    if (name === "From_Dep") {
      setFormData((prev) => ({ ...prev, Worker_Name: "" }));

      if (value) {
        try {
          const response = await axiosInstance.get("/api/presentEmployees");
          const presentWorkers = response.data;
          const filteredWorkers = presentWorkers.filter(
            (worker) => worker.Department === value
          );
          setFilteredPresentWorkers(filteredWorkers);
        } catch (error) {
          console.error("Error fetching filtered present workers:", error);
        }
      } else {
        setFilteredPresentWorkers([]);
      }
    }
  };

  const showAlert = (message, type) => {
    const alertPlaceholder = document.getElementById("alertPlaceholder");
    if(!alertPlaceholder) return;
    const alertHTML = `
    <div class="alert alert-${type} alert-dismissible fade show" role="alert">
      <strong>${type === "success" ? "Success!" : "Error!"}</strong> ${message}
      <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    </div>`;
    alertPlaceholder.innerHTML = alertHTML;
    setTimeout(() => {
      if(alertPlaceholder) alertPlaceholder.innerHTML = "";
    }, 2000);
  };

  // CONTROLLED SUBMISSION LOGIC WITH LINK DIALOG MODAL
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (!formData.From_Dep || !formData.Worker_Name || !formData.To_Department) {
      showAlert("Please select all the required fields.", "danger");
      return;
    }

    setIsSubmitting(true); 

    try {
      const selectedWorker = JSON.parse(formData.Worker_Name);
      const updatedFormData = {
        ...formData,
        Worker_Name: selectedWorker.WorkerName, 
        EmployeeID: selectedWorker.EmployeeID, 
      };

      const response = await axiosInstance.post("/api/worker-allocation", updatedFormData);
      
      setIsAllocationModalOpen(false);
      fetchWorkerAllocations();

      const workerPhone = response.data?.whatsAppNumber || "";
      const workerIdFromDB = response.data?.worker_id || selectedWorker.EmployeeID;

      const preparedMsg = `Hello ${selectedWorker.WorkerName},\n\nYou have been reassigned.\nFrom: ${updatedFormData.From_Dep}\nTo: ${updatedFormData.To_Department}\n\nPlease report to your new department immediately.`;
      
      setWhatsAppPayload({
        worker_id: workerIdFromDB, // API se aaya hua safe ID
        phone: workerPhone,       // Agar khali hoga toh user input kar sakega
        workerName: selectedWorker.WorkerName,
        messageText: preparedMsg
      });

      setIsWhatsAppModalOpen(true);

      setFormData({ From_Dep: "", Worker_Name: "", To_Department: "" });
      setFilteredPresentWorkers([]);

    } catch (error) {
      console.error("Error adding worker allocation:", error);
      showAlert("Failed to add worker allocation. Please try again.", "danger");
    } finally {
      setIsSubmitting(false); 
    }
  };

  // FUNCTION: OPEN EXTERNAL DEEP LINK PROTOCOL WHATSAPP VIA WA.ME
  const handleTriggerWhatsAppUrl = async () => {
    let rawNumber = String(whatsAppPayload.phone).replace(/\D/g, "");

    // Strict 10-Digit Constraint Validation
    if (rawNumber.length !== 10) {
      Swal.fire("Invalid Number!", "Please enter or verify a valid 10-digit mobile number.", "error");
      return;
    }

    try {
      // Background mein permanent master table update trigger hit karo
      await axiosInstance.patch("/api/update-worker-phone", {
        worker_id: whatsAppPayload.worker_id,
        whatsAppNumber: rawNumber
      });

      let formattedNumber = "91" + rawNumber;
      const encodedText = encodeURIComponent(whatsAppPayload.messageText);
      const deepLinkUrl = `https://wa.me/${formattedNumber}?text=${encodedText}`;

      // Open external browser process context channel link
      window.open(deepLinkUrl, "_blank");
      setIsWhatsAppModalOpen(false);
      
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Number verified in Master & WhatsApp opened.",
        timer: 1800,
        showConfirmButton: false
      });
    } catch (error) {
      console.error("Error updating phone:", error);
      Swal.fire("Error", "Failed to save phone number in master registry.", "error");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this allocation?")) {
      return;
    }
    try {
      await axiosInstance.delete(`/api/worker-allocation/${id}`);
      showAlert("Worker allocation deleted successfully!", "success");
      fetchWorkerAllocations(); 
    } catch (error) {
      console.error("Error deleting worker allocation:", error);
      alert("Failed to delete worker allocation. Please try again.");
    }
  };

  const fetchDepartments = async () => {
    try {
      const response = await axiosInstance.get("/api/departments");
      setDepartments(response.data);
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };

  useEffect(() => {
    fetchDepartments();
  }, []);

  const getWorkerNameById = (employeeId) => {
    const user = users.find((user) => user.EmployeeID === employeeId);
    return user ? user.Name : employeeId; 
  };

  const handleCloseModal = () => {
    setFormData({ From_Dep: "", Worker_Name: "", To_Department: "" }); 
    setFilteredPresentWorkers([]); 
    setIsAllocationModalOpen(false); 
  };

  const deptOptions = departments.map((dept) => ({ value: dept, label: dept }));
  
  const workerOptions = filteredPresentWorkers.map((worker) => {
    const wName = getWorkerNameById(worker.EmployeeID);
    return {
      value: JSON.stringify({ EmployeeID: worker.EmployeeID, WorkerName: wName }),
      label: wName,
    };
  });

  return (
    <div className="d-flex dashboard">
      <div className={isSidebarVisible ? "sidebar-container" : "sidebar-hidden"}>
        <Sidebar />
      </div>
      <div id="alertPlaceholder"></div>
      <div className="flex-grow-1">
        <Header
          toggleSidebar={toggleSidebar}
          isSidebarVisible={isSidebarVisible}
        />
        <main className="main-container p-4">
          <table
            style={{
              width: "100%",
              fontSize: "12px",
              borderCollapse: "collapse",
            }}
            className="mb-3"
          >
            <tbody>
              <tr>
                <td style={{ width: "50%", verticalAlign: "top", padding: "8px" }}>
                  <div style={{ display: "grid" }}>
                    <span>
                      <strong style={{ color: "red" }}>Red:</strong> Over Capacity (Above <strong>{limits.RED_LIMIT}</strong>)
                    </span>
                    <span>
                      <strong style={{ color: "green" }}>Green:</strong> All Okay
                    </span>
                    <span>
                      <strong style={{ color: "orange" }}>Orange:</strong> Under Capacity (Below <strong>{limits.ORANGE_LIMIT}</strong>)
                    </span>
                    <span>
                      <strong style={{ color: "blue" }}>Blue:</strong> Process Issue Pending
                    </span>
                    <span>
                      <strong style={{ color: "#cc66ff" }}>Lavender:</strong> Less Workers
                    </span>
                  </div>
                </td>
                <td style={{ width: "50%", verticalAlign: "top", padding: "8px", textAlign: "right" }}>
                  <div style={{ display: "grid" }}>
                    <span>
                      <strong>Present Workers:</strong>{" "}
                      {filteredPresentEmployees.reduce((acc, curr) => acc + curr.PresentEmployees, 0)}
                    </span>
                    <span>
                      <strong>Quantity Wise Workers:</strong> {filteredRequiredResources}
                    </span>
                    <span>
                      <strong>Workers To Fill:</strong>{" "}
                      {Math.max(
                        0,
                        filteredRequiredResources -
                          filteredPresentEmployees.reduce((acc, curr) => acc + curr.PresentEmployees, 0)
                      )}
                    </span>
                    <span>
                      <strong>Reserved Worker:</strong>{" "}
                      {presentEmployees
                        .filter((emp) => emp.Department === "Reserve")
                        .reduce((acc, curr) => acc + curr.PresentEmployees, 0)}
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <div className="mb-0" style={{ display: "none" }}>
            <input
              type="text"
              className="form-control"
              placeholder="Search Item Name"
              style={{ width: "auto" }}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          <div
            className="container-fluid  d-flex justify-content-end align-items-center mb-2"
            style={{ position: "relative" }}
          >
            <p className="font-weight-bold text-uppercase mb-0 mr-2">
              LAST UPDATED TIME &nbsp;
            </p>
            <input
              type="text"
              id="updatedDate"
              readOnly
              style={{ height: "31px", color: "green", maxWidth: "168px" }}
            />
          </div>

          <div className="d-flex align-items-center mb-2">
            <div id="filter-container" className="filter-grid w-100"></div>
          </div>

          <div className="container table-responsive mt-4">
            <div className="d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-outline-primary mb-3 me-3"
                onClick={() => setIsAllocationModalOpen(true)}
              >
                Allocate Workers
              </button>
              <div className="d-flex justify-content-end mb-3">
                <CSVLink
                  data={workerAllocations}
                  headers={csvHeaders}
                  filename="worker_allocations.csv"
                  className="btn btn-success"
                >
                  Export
                </CSVLink>
              </div>
            </div>
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>I D</th>
                  <th>From Department</th>
                  <th>Worker Name</th>
                  <th>To Department</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {workerAllocations.length > 0 ? (
                  workerAllocations.map((allocation) => (
                    <tr key={allocation.ID}>
                      <td>{allocation.ID}</td>
                      <td>{allocation.From_Dep}</td>
                      <td>{allocation.Worker_Name}</td>
                      <td>{allocation.To_Department}</td>
                      <td>
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => handleDelete(allocation.ID)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center">
                      No data available.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="container mt-0">
            <div style={{ position: "absolute" }}>
              <input
                type="text"
                className="form-control"
                placeholder="Search Item Name"
                style={{ width: "auto" }}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>

            <div className="table-responsive">
              <div className="d-flex justify-content-end">
                <button
                  onClick={handleViewAll}
                  type="button"
                  className="btn btn-secondary mb-3"
                >
                  View All
                </button>
              </div>
              <table className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>JOB NO</th>
                    <th>JOB DATE</th>
                    <th>ITEM NAME (LOT ID)</th>
                    <th>PROCESS NAME</th>
                    <th>PROCESS GROUP</th>
                    <th>QUANTITY</th>
                    <th>DEPARTMENT</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData.length > 0 && filteredData[0].errorMessage ? (
                    <tr>
                      <td
                        colSpan="7"
                        className="text-center text-danger font-weight-bold text-uppercase"
                      >
                        {filteredData[0].errorMessage}
                      </td>
                    </tr>
                  ) : (
                    filteredData.map((row, index) => {
                      const rowClass = row["PendingProcess"] === "Yes" ? "table-info" : "";

                      return (
                        <tr key={index} className={rowClass}>
                          <td>
                            <button
                              type="button"
                              className="btn btn-link"
                              onClick={() => {
                                setModalData(row);
                                setIsModalOpen(true);
                              }}
                            >
                              {row["JOB ORDER NO"]}
                            </button>
                          </td>
                          <td>
                            {new Date(row["JOB ORDER DATE"]).toLocaleDateString()}
                          </td>
                          <td>{row["ITEM NAME"]}</td>
                          <td>{row["PROCESS NAME"]}</td>
                          <td>{row["PROCESS GROUP"]}</td>
                          <td>{row["QUANTITY"]}</td>
                          <td>{row["DEPARTMENT"]}</td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </main>
      </div>
      
      {/* Modal JOS Related Data*/}
      {isModalOpen && modalData && (
        <div className="modal show" tabIndex="-1" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Job Order Details</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setIsModalOpen(false)}
                ></button>
              </div>
              <div className="modal-body">
                <p>
                  <strong>Job Order No:</strong> {modalData["JOB ORDER NO"]}
                </p>
                <p>
                  <strong>Description:</strong>{" "}
                  {modalData["Description"] || "No Description"}
                </p>

                {matchedData.length > 0 ? (
                  <div className="table-responsive">
                    <table className="table table-bordered table-striped">
                      <thead>
                        <tr>
                          <th>Rexine Name</th>
                          <th>Black</th>
                          <th>Brown</th>
                          <th>Tan</th>
                          <th>Lot ID</th>
                        </tr>
                      </thead>
                      <tbody>
                        {matchedData.map((row, index) => (
                          <tr key={index}>
                            <td>{row["REXINE NAME"]}</td>
                            <td>{row["BLACK"]}</td>
                            <td>{row["BROWN"]}</td>
                            <td>{row["TAN"]}</td>
                            <td>{row["LOT ID"]}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <p>No Design data found.</p>
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setIsModalOpen(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* MODAL FOR WORKER ALLOCATION */}
      {isAllocationModalOpen && (
        <div className="modal show" tabIndex="-1" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header bg-light">
                <h5 className="modal-title fw-bold">Add Worker Allocation</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseModal}
                ></button>
              </div>
              <form onSubmit={handleFormSubmit}>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label fw-semibold">From Department</label>
                    <Select
                      name="From_Dep"
                      options={deptOptions}
                      value={deptOptions.find(op => op.value === formData.From_Dep) || null}
                      onChange={(option, actionMeta) => handleReactSelectChange(option, { name: "From_Dep" })}
                      placeholder="Search Department..."
                      isClearable
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-semibold">Worker Name</label>
                    <Select
                      name="Worker_Name"
                      options={workerOptions}
                      value={workerOptions.find(op => op.value === formData.Worker_Name) || null}
                      onChange={(option, actionMeta) => handleReactSelectChange(option, { name: "Worker_Name" })}
                      placeholder="Search Worker..."
                      isClearable
                      noOptionsMessage={() => "Select 'From Department' first or no workers available"}
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-semibold">To Department</label>
                    <Select
                      name="To_Department"
                      options={deptOptions}
                      value={deptOptions.find(op => op.value === formData.To_Department) || null}
                      onChange={(option, actionMeta) => handleReactSelectChange(option, { name: "To_Department" })}
                      placeholder="Search Department..."
                      isClearable
                    />
                  </div>
                </div>
                <div className="modal-footer bg-light">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleCloseModal}
                  >
                    Close
                  </button>
                  <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                    {isSubmitting ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Saving...
                      </>
                    ) : (
                      "Save Changes"
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* 💬 PRO LEVEL SAAS WHATSAPP MODAL: FULLY EDITABLE NUMBER FLOW */}
      {isWhatsAppModalOpen && (
        <div className="modal show" tabIndex="-1" style={{ display: "block", backgroundColor: "rgba(15, 23, 42, 0.6)", backdropFilter: "blur(6px)", zIndex: 1060 }}>
          <div className="modal-dialog modal-lg modal-dialog-centered" style={{ maxWidth: "650px" }}>
            <div className="modal-content border-0 shadow-2xl" style={{ borderRadius: "16px", overflow: "hidden" }}>
              
              {/* Pro Header */}
              <div className="modal-header bg-success text-white px-4 py-3 border-0" style={{ background: "linear-gradient(135deg, #198754 0%, #146c43 100%)" }}>
                <h5 className="modal-title d-flex align-items-center gap-2 fw-bold" style={{ fontSize: "1.15rem", letterSpacing: "0.5px" }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" className="bi bi-whatsapp" viewBox="0 0 16 16">
                    <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.69-4.982c-.193-.097-1.14-.563-1.317-.627-.177-.063-.306-.095-.434.096-.127.19-.493.628-.604.753-.11.125-.221.139-.414.042-.193-.096-.815-.3-1.554-.959-.574-.513-.96-1.148-1.072-1.34-.112-.192-.012-.296.085-.392.087-.087.194-.225.29-.338.097-.114.129-.192.194-.321.064-.13.032-.241-.016-.338-.048-.097-.434-1.044-.595-1.432-.157-.379-.313-.328-.434-.334-.112-.006-.24-.006-.368-.006-.128 0-.337.048-.513.24-.176.192-.672.656-.672 1.6s.688 1.854.784 1.982c.096.128 1.353 2.064 3.28 2.894.459.197.817.314 1.096.402.461.147.88.127 1.213.078.371-.056 1.14-.465 1.301-.915.16-.451.16-.838.112-.915-.048-.078-.176-.125-.369-.221"/>
                  </svg>
                  Notification Control Center
                </h5>
                <button type="button" className="btn-close btn-close-white shadow-none" onClick={() => setIsWhatsAppModalOpen(false)}></button>
              </div>

              {/* Modal Body */}
              <div className="modal-body p-4 bg-light" style={{ backgroundColor: "#f8fafc" }}>
                
                {/* 2-Column Side-by-Side Unified Layout */}
                <div className="row g-3 mb-4">
                  
                  {/* Worker Name Display (Read-Only Card) */}
                  <div className="col-md-6">
                    <div className="bg-white p-3 rounded-3 shadow-sm border border-light h-100 d-flex flex-column justify-content-center" style={{ minHeight: "85px" }}>
                      <span className="text-muted small text-uppercase fw-semibold d-block mb-1" style={{ fontSize: '0.75rem', color: '#64748b' }}>
                        Worker Name
                      </span>
                      <h5 className="fw-bold text-dark mb-0">{whatsAppPayload.workerName}</h5>
                    </div>
                  </div>
                  
                  {/* Editable WhatsApp Number Input Field (Sleek Borderless UI) */}
                  <div className="col-md-6">
                    <div 
                      className="p-3 rounded-3 shadow-sm d-flex flex-column justify-content-center h-100" 
                      style={{ 
                        minHeight: "85px", 
                        backgroundColor: !whatsAppPayload.phone ? "#fff5f5" : "#ffffff", // Missing par halka soft red, hone par clear white
                        border: "1px solid #e2e8f0" // Ekdum halki standard clean border
                      }}
                    >
                      <span 
                        className={`small text-uppercase fw-bold d-block mb-1 ${!whatsAppPayload.phone ? 'text-danger' : 'text-success'}`} 
                        style={{ fontSize: '0.75rem', letterSpacing: '0.3px' }}
                      >
                        <i className={`bi ${!whatsAppPayload.phone ? 'bi-exclamation-triangle-fill animate-pulse' : 'bi-pencil-square'}`}></i>&nbsp;
                        {!whatsAppPayload.phone ? "Missing Contact - Enter No." : "Verify / Change WhatsApp No."}
                      </span>
                      
                      <div className="input-group input-group-sm bg-light rounded-2 overflow-hidden" style={{ border: "1px solid #cbd5e1" }}>
                        <span className="input-group-text border-0 fw-bold text-secondary px-2" style={{ fontSize: '0.9rem', backgroundColor: '#f1f5f9' }}>+91</span>
                        <input 
                          type="text" 
                          maxLength={10}
                          className="form-control border-0 bg-transparent fw-bold text-dark"
                          placeholder="Type 10-Digit Mobile No." 
                          value={whatsAppPayload.phone}
                          onChange={(e) => setWhatsAppPayload(prev => ({ ...prev, phone: e.target.value.replace(/\D/g, "") }))}
                          style={{ fontSize: '1rem', height: '34px', letterSpacing: '0.5px', boxShadow: 'none' }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Pre-filled Editable Template Message Box (Height Maintained to 8 Rows) */}
                <div className="mb-0 bg-white p-3 rounded-3 shadow-sm border border-light">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <label className="form-label fw-semibold text-muted small text-uppercase mb-0" style={{ fontSize: '0.75rem' }}>
                      Message Body Configuration
                    </label>
                    <span className="badge bg-secondary bg-opacity-10 text-secondary fw-medium rounded-pill px-2 py-1" style={{ fontSize: '0.70rem' }}>
                      Editable Template
                    </span>
                  </div>
                  <textarea
                    className="form-control bg-light border-0 shadow-none"
                    rows="8"
                    value={whatsAppPayload.messageText}
                    onChange={(e) => setWhatsAppPayload(prev => ({ ...prev, messageText: e.target.value }))}
                    style={{ whiteSpace: "pre-wrap", resize: "none", fontSize: "0.95rem", color: '#334155', borderRadius: '8px', padding: '12px' }}
                  ></textarea>
                </div>

                <div className="mt-3 p-3 rounded-3 d-flex align-items-start gap-2" style={{ backgroundColor: "#f0f4f8", borderLeft: "3px solid #64748b", borderRadius: "8px" }}>
                  <i className="bi bi-info-circle-fill" style={{ color: "#64748b", fontSize: "1.1rem", marginTop: "-2px" }}></i>
                  <span className="text-dark small" style={{ fontSize: '0.78rem', color: '#334155', fontWeight: '500', lineHeight: '1.4' }}>
                    <strong>Note:</strong> Number modification will update the employee profile configuration in master record automatically.
                  </span>
                </div>

              </div>

              {/* Modal Footer Controls */}
              <div className="modal-footer bg-light border-0 px-4 py-3 rounded-bottom-4 d-flex justify-content-end gap-2">
                <button type="button" className="btn btn-secondary text-white text-decoration-none rounded-pill px-4 fw-medium" onClick={() => setIsWhatsAppModalOpen(false)}>
                  Skip Notification
                </button>
                <button type="button" className="btn btn-success rounded-pill px-4 py-2 fw-bold shadow-sm d-inline-flex align-items-center gap-2" onClick={handleTriggerWhatsAppUrl} style={{ background: "linear-gradient(135deg, #198754 0%, #146c43 100%)", border: "none" }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-box-arrow-up-right" viewBox="0 0 16 16">
                    <path fillRule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5"/>
                    <path fillRule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"/>
                  </svg>
                  Save & Open WhatsApp
                </button>
              </div>

            </div>
          </div>
        </div>
      )}

    </div>
  );
}

export default Dashboard;